import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { ResidentialHeroSection } from '@trashlab/sitesapp/src/templates/redebins/components/residential/residential-hero-section';
import { BenefitsSection } from '@trashlab/sitesapp/src/templates/redebins/components/residential/benefits-section';
import { KnowBeforeThrow } from '@trashlab/sitesapp/src/templates/redebins/components/residential/know-before-throw';
import { DumpsterOptions } from '@trashlab/sitesapp/src/templates/redebins/components/residential/dumpster-options';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/templates/redebins/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/templates/redebins/components/shared/service-areas-section';

const ResidentialPage = () => {
  return (
    <>
      <ResidentialHeroSection />
      <BenefitsSection />
      <KnowBeforeThrow />
      <DumpsterOptions />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/residential',
  component: ResidentialPage,
});

